import styled from "styled-components";
import kitchenSrc from "assets/images/kitchen.png";
import kitchenHoverSrc from "assets/images/hover/kitchen-hover.png";
import buymerchSrc from "assets/images/bubbleText/buymerch.png";

export const ImgWrapper = styled.div`
  position: absolute;
  display: block;
  width: 15%;
  height: 27%;
  top: 15.4rem;
  left: 1.4rem;

  background-image: url(${kitchenSrc});
  background-size: contain;
  background-repeat: no-repeat;
  cursor: pointer;

  :hover {
    background-image: url(${kitchenHoverSrc});
    ::after {
      position: absolute;
      background-image: url(${buymerchSrc});
      background-size: contain;
      display: inline-block;
      width: 100%;
      height: 50%;
      content: "";
      background-repeat: no-repeat;
      top: 0;
      right: 0;
      transform: translate(57%, 45%);
    }
  }
  ${({ theme }) => theme.mediaWidth.upToMedium`
    top: 32.6vw;
    left: 3vw;
  `}
`;
